import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { pt } from 'vuetify/lib/locale'
import { en } from 'vuetify/lib/locale'

Vue.use(Vuetify)

export default new Vuetify({
  // 'ptbr' era usado sem estar registrado, e tabelas/calendários caíam no inglês
  lang: {
    locales: { ptbr: pt, pt, en },
    current: 'ptbr'
  },
  // lang: {
  //   locales: {
  //     pt,
  //     en
  //   },
  //   current: 'pt'
  // },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#0554b5',
        secondary: '#FFFFFF',
        dark: '#111111',
        gray: '#F7F7F7',
        lightGray: '#EFEFEF',
        offWhite: '#F2F2F2',
        black: '#101828',
        mediumBlack: '#0F0F0F',
        mediumGray: '#959595',
        darkGray: '#9E9E9E',
        important: '#FB3A04',
        lightImportant: '#FEF2F2',
        white: '#FFFFFF',
        accent: '#4CAF50',
        error: '#D32F2F',
        success: '#2E7D32',
        warning: '#F59E0B',
        info: '#0277BD',
        background: '#EDF2F8',
        border: '#D6E0EE',
        yellow:'#FFC400',
        blue:'#039BE5',
        green:'#00C853',
        red:'#E53935',

      }
    }
  }
})
